import styled from 'styled-components';
import Color from '../../../utils/colors.constants';

const Details = styled.div`
width: 100%;
display:flex;
border-bottom: 2px solid ${Color.AZUL_CLARO};

`;

export default Details;
